import { IBillingScheduleDetail, IScheduleAndEvent } from './../../../core/interfaces/billing.interface';
import { BilledService } from './billed.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { getDateFormatted } from 'app/utils/helpers';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { PaginatorCustomService } from 'app/utils/paginator-custom/paginator-custom.service';
import { Subscription } from 'rxjs/Subscription';
import { MyTripsGridService } from 'app/utils/my-trips-grid/my-trips-grid.service';
import { BillingStatusEnum } from 'app/core/enums/billing-status.enum';
import { ISummary } from 'app/core/interfaces/summary-interface';
import { IDetailResponse } from 'app/core/interfaces/trip-detail.interface';
import { PayorService } from 'app/core/services/payor.service';
import { BtnsForGridService } from 'app/utils/btns-for-grid/btns-for-grid.service';
import { BillingScheduleService } from 'app/utils/billing-scheduled-edit/billing-schedule.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { IDenialCategory } from 'app/core/interfaces/deposit.interface';
import { take } from 'rxjs/operators';
import swal, { SweetAlertResult } from 'sweetalert2';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { ITripStatus } from 'app/core/interfaces/schedule-trip.interface';
import { IMultiselectItem } from './billed-interface';
import { GridLayoutStore } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-billed',
  templateUrl: './billed.component.html',
  styleUrls: ['./billed.component.scss'],
  providers: [GridLayoutStore]
})
export class BilledComponent extends ParentModule implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  activeTabs = activeTab;
  tabs: any;
  billedForm: FormGroup;
  dropdownSettings = {};
  tripStatusDropdownSettings = {};
  payorTypes = [];
  payorList = [];
  tripStatusList: ITripStatus[] = [];
  statusList = [];
  denialCategoryList = [];
  showInactive = false;
  typePayorSelected = null;
  tripStatusSelected = null;
  agingData = [];
  billingScheduleList: IScheduleAndEvent[] = [];
  eventSchedule: IBillingScheduleDetail[] = [];
  btnScheduleDisabled: boolean;
  disabledBtnExportExcel: boolean;
  dataGridMassMove = [];
  myDatePickerOptions = {
    dateFormat: 'yyyy-mm-dd'
  };
  constructor(
    private fb: FormBuilder,
    private billedService: BilledService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    private paginatorCustomService: PaginatorCustomService,
    private myTripsGridService: MyTripsGridService,
    private payorService: PayorService,
    private btnsForGridService: BtnsForGridService,
    private billingScheduleService: BillingScheduleService,
    private dataProcessingService: DataProcessingService,
    private reservationService: ReservationService,
    protected Inject: Injector,
  ) {
    super('app-billed', Inject);
    this.initForm();
  }

  ngOnInit() {
    this.initComponent();
  }

  subscribeStatusForm() {
    this.subscriptions.push(
      this.billedForm.statusChanges.subscribe((status) => {
        this.paginatorCustomService.selectDisabled(status === 'VALID');
      })
    );
  }

  loadTripStatus(): void {
    this.subscriptions.push(
      this.reservationService.getTripStatus().subscribe((res) => {
        if (res && res.length) {
          this.tripStatusList = res.map((item: ITripStatus) => {
            return {
              id: item.tripstatusid,
              itemName: item.description
            };
          });
        }
      }, (error) => {
        this.sweetAlertHelper.captureException(error);
      })
    );
  }

  initComponent() {
    this.changeTab(this.activeTabs.summary);
    this.currentDate();
    this.dropdownSettingsConfig();
    this.initServices();
    this.observables();
    this.getBillingStatuses();
    this.subscribeStatusForm();
    this.loadTripStatus();
    this.loadAgingData();
  }

  dropdownSettingsConfig() {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select payor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
    this.tripStatusDropdownSettings = {
      singleSelection: false,
      text: 'Select trip status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
  }

  initServices() {
    this.subscriptions.push(
      this.billedService.getPayorsType().subscribe((res) => {
        if (res) {
          this.payorTypes = res;
        }
      }, (error) => {
        this.sweetAlertHelper.captureException(error);
      })
    );

    this.subscriptions.push(
      this.billedService.getPayorsAll().subscribe((res) => {
        if (res && res.length) {
          this.payorList = res.map((p: any) => {
            return { id: p.payorid, itemName: p.description };
          });
        }
      },
        (error) => {
          this.sweetAlertHelper.captureException(error);
        })
    );

    this.subscriptions.push(
      this.billedService.getBillingSchedule().subscribe((res) => {
        if (res && res.length) {
          this.billingScheduleList = res;
        }
      }, (error) => this.sweetAlertHelper.captureException(error))
    );
  }

  observables() {
    this.subscriptions.push(
      this.paginatorCustomService.quantityByPage$.subscribe((res) => {
        if (res) {
          this.billedForm.get('rows').setValue(res);
          this.onRun();
        }
      })
    );
    this.subscriptions.push(
      this.paginatorCustomService.reloadByPage$.subscribe((data: number) => {
        if (data) {
          this.billedForm.get('page').setValue(data);
          this.onRun();
        }
      })
    );
    this.subscriptions.push(
      this.billedService.dataFilter$.subscribe((data) => {
        if (data && Object.keys(data).length) {
          this.tripsDetails(data);
        }
      })
    );

    this.subscriptions.push(
      this.billedService.scheduelEvent.subscribe((event) => {
        if (!event.event) {
          this.btnScheduleDisabled = event.disabled;
        }
      })
    );
    this.subscriptions.push(
      this.billingScheduleService.eventSave.subscribe((event) => {
        if (event && this.billedForm.valid) {
          this.onRun();
        }
      })
    );

    this.subscriptions.push(
      this.billingScheduleService.formData$.subscribe((data: any) => {
        if (data && data.length) {
          this.dataGridMassMove = data;
        }
      })
    );
  }

  initForm() {
    this.billedForm = this.fb.group({
      billingstatusid: [null, Validators.required],
      initialdate: [null],
      finaldate: [null],
      dateRange: [null, Validators.required],
      agingDate: true,
      payoridslist: [null, Validators.required],
      page: [1],
      rows: [1000],
      agingranges: [null],
      billingschedules: [null],
      billingscheduledetailids: [null],
      denialcategoryid: [null],
      categorized: false,
      tripstatusidslist: [null],
    });

    this.billedForm.get('billingschedules').valueChanges.subscribe((id: number) => {
      this.billedForm.get('billingscheduledetailids').setValue(null);
      this.eventSchedule = [];
      if (id) {
        this.getDetailsEvent(id);
      }
    });
  }

  getDetailsEvent(id: number) {
    const data = this.billingScheduleList.find(item => item.billingscheduleid === id);
    if (data && data.billingscheduledetails.length) {
      this.eventSchedule = data.billingscheduledetails;
    }
  }

  changeTab(tab) {
    this.tabs = tab;
    this.btnScheduleDisabled = false;
    this.restartObservables();
    this.setValidatorBillingStatus();
    if (this.billedForm.valid) {
      this.onRun();
    }
    this.getDenialReasonsCategory();
  }

  currentDate() {
    const today = new Date();
    const beginDate = new Date(today);
    beginDate.setMonth(beginDate.getMonth() - 3);
    today.setDate(today.getDate() - 1);

    const [formattedMonthP, formattedDayP, formattedYearP] =
      CustomDate.convertToFloridaTimezone(today);

    const [beginMonth, beginDay, beginYear] =
      CustomDate.convertToFloridaTimezone(beginDate);

    this.billedForm.patchValue({
      dateRange: {
        beginDate: {
          day: beginDay,
          month: beginMonth,
          year: beginYear,
        },
        endDate: {
          day: formattedDayP,
          month: formattedMonthP,
          year: formattedYearP,
        },
      },
    });
  }

  onRun() {
    const formData = Object.assign({}, this.billedForm.value);
    if (formData && formData.dateRange && formData.dateRange.beginDate) {
      formData.initialdate = CustomDate.formatJs( CustomDate.formatFromObject(formData.dateRange.beginDate), 'MM-dd-yyyy');
    }

    if (formData && formData.dateRange && formData.dateRange.endDate) {
      formData.finaldate = CustomDate.formatJs(CustomDate.formatFromObject(formData.dateRange.endDate), 'MM-dd-yyyy');
    }
    formData.payoridslist = formData.payoridslist.map((item) => { return item.id; });

    this.t2LoadingService.show();
    this.billedService.triggerCloseModal(true);
    const cases = {
      'summary': () => this.getSummaryData(formData),
      'details': () => this.getDetailsData(formData),
      'denials': () => this.getBillingStatuData(formData),
      'movement': () => this.getMovementsData(formData),
    };
    return cases[activeTab[this.tabs]]();
  }

  sendPaginatorData(resp) {
    if (resp) {
      const { data, page, totalitems, totalpages } = resp;
      this.paginatorCustomService.getResulServiceData(
        { itemsforpage: data.length, page: page, totalitems: totalitems, totalpages: totalpages });
      this.billedForm.get('page').setValue(1);
    }
  }

  getSummaryData(formData) {
    const body = {
      Payors: formData.payoridslist,
      BillingStatusId: formData.billingstatusid[0],
      startDate: formData.initialdate,
      endDate: formData.finaldate
    };
    this.subscriptions.push(
      this.billedService.getSummary(body).subscribe((resp: ISummary) => {
        if (resp) {
          this.billedService.getSummaryData(resp);
          this.disableBtnExcel(resp);
        }
        this.t2LoadingService.hiden();
      }, (error) => {
        this.sweetAlertHelper.captureException(error).then(() => {
          this.t2LoadingService.hiden();
        });
      })
    );
  }

  getDetailsData(formData) {
    if (formData) {
      delete formData.billingschedules;
      delete formData.billingscheduledetailids;
      this.myTripsGridService.getDataForm(formData);
      this.subscriptions.push(
        this.billedService.getTripsToExport(formData).subscribe((res: IDetailResponse) => {
          if (res && res.data) {
            this.sendObservables(res);
            this.disableBtnExcel(res.data);
          }
          this.t2LoadingService.hiden();
        }, (error) => {
          this.sweetAlertHelper.captureException(error).then(() => {
            this.t2LoadingService.hiden();
          });
        })
      );
    }
  }

  getMovementsData(formData) {
    if (formData.billingschedules && !formData.billingscheduledetailids) {
      formData.billingschedules = [formData.billingschedules];
      formData.billingscheduledetailids = this.eventSchedule.map(item => item.billingscheduledetailid);
    } else {
      formData.billingscheduledetailids = formData.billingscheduledetailids ? [formData.billingscheduledetailids] : [];
      formData.billingschedules = !formData.billingschedules ? [] : [formData.billingschedules];
    }
    formData.billingstatusid = formData.billingstatusid[0];
    formData.payortypes = this.validatePayorType();
    formData.tripstatusidslist = formData.tripstatusidslist && formData.tripstatusidslist.length 
      ? formData.tripstatusidslist.map((item: IMultiselectItem) => item.id) 
      : [];

    delete formData.billingschedules;
    this.subscriptions.push(
      this.billedService.getMassMovement(formData).subscribe((resp) => {
        if (resp && resp.data) {
          this.sendPaginatorData(resp);
          this.billedService.getDataMovement(resp.data);
          this.disableBtnExcel(resp.data);
        }
        this.t2LoadingService.hiden();
      }, (error) => {
        this.sweetAlertHelper.captureException(error)
          .then(() => this.t2LoadingService.hiden());
      })
    );
  }

  getBillingStatuData(formData) {
    delete formData.billingschedules;
    delete formData.billingscheduledetailids;
    formData.billingstatusid = [BillingStatusEnum.Denied];
    this.subscriptions.push(
      this.billedService.getBillingStatusDenial(formData).subscribe((res: IDetailResponse) => {
        if (res && res.data) {
          this.sendPaginatorData(res);
          this.billedService.getDataDenials(res.data);
          this.disableBtnExcel(res.data);
        }
        this.t2LoadingService.hiden();
      }, (error) => {
        this.sweetAlertHelper.captureException(error).then(() => {
          this.t2LoadingService.hiden();
        });
      })
    );
  }

  validatePayorType() {
    if (this.typePayorSelected == null) {
      return this.payorTypes.map(item => item.payortypeid);
    } else {
      return this.typePayorSelected !== String(null) ?
        [Number(this.typePayorSelected)] : this.payorTypes.map(item => item.payortypeid);
    }
  }

  sendObservables(res) {
    this.myTripsGridService.getDataForGrid(res.data);
    this.sendPaginatorData(res);
  }



  onTypePayor(idPayor: number) {
    if (idPayor !== undefined) {
      this.typePayorSelected = idPayor;
      this.subscriptions.push(
        this.payorService.getTypePayorsInactive(idPayor, this.showInactive).subscribe((resp) => {
          if (resp && resp.length) {
            this.onClearPayors();
            this.payorList = [];
            this.payorList = resp.map((p: any) => {
              return { id: p.payorid, itemName: p.description };
            });
          }
        }, (error) => {
          this.sweetAlertHelper.captureException(error);
        })
      );
    }
  }

  onClearPayors() {
    this.billedForm.get('payoridslist').setValue(null);
    this.billedForm.get('billingstatusid').setValue(null);
    this.setValidatorBillingStatus();
    this.myTripsGridService.getDataForGrid([]);
    this.billedService.getSummaryData([]);
    this.paginatorCustomService.getResulServiceData(undefined);
  }

  get payorSelected(): number {
    const payorselected = this.billedForm.get('payoridslist').value;
    if (payorselected && payorselected.length) {
      return this.billedForm.get('payoridslist').value.length;
    }
  }

  get validForm(): boolean {
    return this.billedForm.invalid;
  }

  getBillingStatuses(): void {
    this.subscriptions.push(
      this.billedService.getBillingStatus().subscribe({
        next: (res) => {
          if (res && res.length) {
            res.map(
              (item: {
                billingstatusid: BillingStatusEnum;
                description: any;
              }) => {
                  this.statusList.push({
                    id: [Number(item.billingstatusid)],
                    description: item.description,
                  });
              }
            );
          }
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        },
      })
    );
  }

  onShowInactivePayor(inactive: boolean) {
    this.showInactive = inactive;
    this.onTypePayor(this.typePayorSelected);
  }

  loadAgingData() {
    this.agingData = [
      { id: null, description: 'All', code: '0' },
      { id: 1, description: '0 - 30', code: '030' },
      { id: 2, description: '31 - 60', code: '3160' },
      { id: 3, description: '61 - 90', code: '6190' },
      { id: 4, description: '91 - 120', code: '91120' },
      { id: 5, description: 'over 121 days', code: '121' },
    ];
  }

  tripsDetails(data) {
    if (data && this.billedForm.valid) {
      const payorSelected = this.payorList.find(item => item.itemName === data.payor);
      const aginSelected = this.agingData.find(item => item.code === data.aging);
      if (payorSelected && aginSelected) {
        this.billedForm.patchValue(
          {
            payoridslist: [payorSelected],
            agingranges: aginSelected.id
          },
        );
        this.changeTab(activeTab.details);
      }
    }
  }

  onSchedule() {
    this.billedService.scheduelEvent.emit({ event: true });
  }

  restartObservables(): void {
    this.billedForm.get('rows').setValue(1000);
    this.paginatorCustomService.getResulServiceData(undefined);
    this.btnsForGridService.btnDisabled(null);
  }

  setValidatorBillingStatus() {
    if (this.tabs === this.activeTabs.denials) {
      this.billedForm.get('billingstatusid').setValidators(null);
      this.billedForm.get('billingstatusid').updateValueAndValidity();
    } else {
      this.billedForm.get('billingstatusid').setValidators([Validators.required]);
      this.billedForm.get('billingstatusid').updateValueAndValidity();
    }
  }

  exportToExcel() {
    this.billedService.exporToExcel.emit(true);
  }

  disableBtnExcel(data) {
    this.disabledBtnExportExcel = !!data.length;
  }

  onRecalculate(): void {
    if (this.dataGridMassMove && this.dataGridMassMove.length) {
      this.t2LoadingService.show();
      const tripId = this.dataGridMassMove.map(item => item.tripid);
      this.dataProcessingService.recalcualteData(tripId)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe((res) => {
          if (res) {
            this.sweetAlertHelper.createCustomAlert({ title: 'Succes', text: res.message, type: 'success' })
              .then(() => {
                if (this.billedForm.valid) {
                  this.onRun();
                  this.btnScheduleDisabled = false;
                }
              });
          }
        }, error => this.sweetAlertHelper.captureException(error));
    }
  }

   getDenialReasonsCategory(): void {
    if (this.tabs !== this.activeTabs.denials) {
      return;
    }
    this.billedService.getDenialsCategory().subscribe({
      next: (value: IDenialCategory[]) => {
        if (value && value.length) {
          this.denialCategoryList = value;
          this.billedService.setDenialCategories(value);
        }
      },
      error: (err) => {
        this.sweetAlertHelper.captureException(err);
      }
    });
  }

   autoAssignDenialCategory(): void {
    this.billedService.triggerOpenModalAssignCategory(true);
    this.subscriptions.push(
      this.billedService.tripIds$
        .pipe(take(1))
        .finally(() => this.billedService.setTripIds(null))
        .subscribe((tripIds: number[]) => {
          if (tripIds && tripIds.length) {
            this.sweetAlertHelper
              .createCustomAlert({
                title: 'Are you sure?',
                text: 'This action will assign the corresponding category to the selected trips.',
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'No',
                cancelButtonText: 'Yes',
              })
              .then((result: SweetAlertResult) => {
                if (result && result.dismiss === swal.DismissReason.cancel) {
                  this.billedService
                    .autoAssignDenialCategory(tripIds)
                    .subscribe({
                      next: (res) => {
                        if (res) {
                          this.sweetAlertHelper
                            .createCustomAlert({
                              title: 'Success',
                              text: res.message,
                              type: 'success',
                            })
                            .then(() => {
                              if (this.billedForm && this.billedForm.valid) {
                                this.onRun();
                              }
                            });
                        }
                      },
                      error: (err) => {
                        this.sweetAlertHelper.captureException(err);
                      },
                    });
                }
              });
          }
        })
    );
  }

  get detailsPayor(): string {
    return `Payors (Qty: ${this.payorList.length}, Sel: ${!this.payorSelected ? 0 : this.payorSelected})`;
  }

  get getTabsSummary(): boolean {
    return this.tabs === this.activeTabs.summary;
  }

  get getTabsDetails(): boolean {
    return this.tabs === this.activeTabs.details;
  }

  get getTabsDenials(): boolean {
    return this.tabs === this.activeTabs.denials;
  }

  get getTabsMovement(): boolean {
    return this.tabs === this.activeTabs.movement;
  }

  get showBtnRecalculate(): boolean {
    const billingstatusid = this.billedForm.get('billingstatusid').value;
    if (billingstatusid) {
      const firstStatus = Array.isArray(billingstatusid)
        ? billingstatusid.find((item) => item)
        : billingstatusid;
      return (firstStatus === BillingStatusEnum.Verified) && this.getTabsMovement;
    }
  }

  get isAgingDate(): boolean {
    return this.billedForm.get('agingDate').value;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}

enum activeTab {
  summary = 1,
  details = 2,
  denials = 3,
  movement = 4
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billed/billed.component.ts